import { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import Header from '../../components/Header/header'
import { connect } from 'react-redux'
import ScholarshipTest from 'components/scholarship-test/ScholarshipTest'
import useGetApi from 'api/useGetApi'
import CONFIG from '../../config'
import {
    SET_PROFILE_DATA, SET_DASHBOARD_API_DATA, SET_TOAST_DATA, RESET_REDUCERS,
    SET_VISIBLE_COURSE_DESC, SET_VISIBLE_COURSE_REGISTER, SET_ECOMMERCE_SUCCESS, SET_ECOMMERCE_FAILED
} from 'constants/actionTypes'
import { extractQueryParams } from 'utils/getAllURLParameters'
import { usePutPostApi } from 'api/usePutPostApi'
import ResultPage from 'Layout/AntheResult/ResultPage'
import Loader from 'components/Result/AntheResults/components/Loader'
import ECommerceSuccessful from 'components/ECommerce/ECommerceSuccessful'
import CourseDescription from 'components/ECommerce/CourseDescription'
import RegistartionSteps from 'components/RegistrationSteps/RegistartionSteps'

import { trackWebEngageEvent, params as webengage_params } from '../../utils/customWebengageEvents'

const mapStateToProps = (state) => {
    return {
        token: state?.token,
        profileInfo: state?.profileData,
        dashboardInfo: state?.dashboardData,
        ecommerce: state?.ecommerce,
        tpResultData: state?.tpResultData
    }
}

const mapDispatchToProps = (dispatch) => ({
    setProfileData: (payload) => {
        dispatch({ type: SET_PROFILE_DATA, payload: payload })
    },
    setDashboardData: (payload) => {
        dispatch({ type: SET_DASHBOARD_API_DATA, payload: payload })
    },
    setToastMsgsData: (payload) => {
        dispatch({ type: SET_TOAST_DATA, payload })
    },
    setCourseDescVisible: (payload) => {
        dispatch({ type: SET_VISIBLE_COURSE_DESC, payload })
    },
    setCourseRegisterVisible: (payload) => {
        dispatch({ type: SET_VISIBLE_COURSE_REGISTER, payload })
    },
    setecommerceSuccess: (payload) => {
        dispatch({ type: SET_ECOMMERCE_SUCCESS, payload })
    },
    setecommerceFailed: (payload) => {
        dispatch({ type: SET_ECOMMERCE_FAILED, payload })
    },
    setResetReducer: () => {
        dispatch({ type: RESET_REDUCERS })
    },
})

const Dashboard = (props) => {

    let date = new Date();
    const location = useLocation()
    const history = useHistory()

    const [finalEditDetailsPayload, setFinalPayload] = useState({})
const Domain = window.location.hostname
    const isAkTheDomain = Domain.includes('akthedashboard');
    let parameters = {}
    const queryString = window.location.search
    const queryParamsArray = queryString.replace('?', '').split(/&|=/)
    parameters = extractQueryParams(queryParamsArray)
    let isPaymentParam = parameters.hasOwnProperty('status') && parameters.hasOwnProperty('mode')

    // Fetch Profile data
    const {
        data: profileData,
        loading,
        error,
        setEnabled: fetchProfileData,
    } = useGetApi(CONFIG.PROFILE_API, props?.token, true)

    // Fetch dashboard data
    const {
        data: dashboardData,
        loading: isDashboardloading,
        dashboarderror,
        setEnabled: fetchDashboardData,
    } = useGetApi(CONFIG.DASHBOARD_API, props?.token, true)

    // Update profile
    const {
        data: updateDetailsResponse,
        isLoading,
        errors,
        setPutEnabled: handleEditDetailsSubmit,
    } = usePutPostApi(CONFIG.UPDATE_EXAM_INFO_API, props?.token, 'post', finalEditDetailsPayload, false)

    const [isLoader, setIsLoading] = useState(isLoading || loading || isDashboardloading || true)

    useEffect(() => {
        document.body.style.zoom = '100%'
        if (!props?.token && location.pathname !== '/result')
            return history.push('/')
    }, [])

    useEffect(() => {
        if (isPaymentParam && parameters.hasOwnProperty('editExam')) {
            const updateDetails = localStorage.getItem('originalProfileData')
            const restoredArr = JSON.parse(updateDetails)
            let updateDetailsPayload = { ...restoredArr, 'payment status': parameters.status || '' }

        if (parameters.editExam === 'true') {
                const exam_type = profileData?.exam_type || 'ANTHE'; // fallback if undefined
                const eventName =
                    exam_type === 'AKTHE'
                        ? 'AKTHE_db_confirm_exam_detail_update'
                        : 'ANTHE_db_confirm_exam_detail_update';

                window.webengage.track(eventName, updateDetailsPayload);
        }
        }
    }, [isPaymentParam])

    useEffect(() => {
        if (updateDetailsResponse && updateDetailsResponse.success && updateDetailsResponse.success === 'true') {
            setIsLoading(loading || isLoading || isDashboardloading)
            history.push('/dashboard')
            fetchProfileData(true)

            setTimeout(() => {
                props.setToastMsgsData({
                    isToastOpen: true,
                    toastType: 'Success',
                    toastMessage: updateDetailsResponse.msg,
                })
            }, 700)
        } else if (updateDetailsResponse && updateDetailsResponse.success && updateDetailsResponse.success === 'false') {
            setIsLoading(loading || isLoading || isDashboardloading)
            setTimeout(() => {
                props.setToastMsgsData({
                    isToastOpen: true,
                    toastType: 'danger',
                    toastMessage: 'Something went wrong. Please try again later.',
                })
            }, 700)
        }
    }, [updateDetailsResponse])

    useEffect(() => {
        if (parameters.status === 'success' && parameters.editExam === 'true') {
            const getEditExamDetails = JSON.parse(localStorage.getItem('editExamDetails'))
            setFinalPayload({ ...getEditExamDetails })

            handleEditDetailsSubmit(true)
        } else setIsLoading(false)
    }, [parameters.editExam])

    // Show success & failure page and Send webEngage event for the same
    useEffect(() => {
        //setting global obj values again after returning from payment gateway
        webengage_params.mobile_number = props?.profileInfo?.mobile_number;
        webengage_params.roll_number = props?.profileInfo?.roll_number;
        webengage_params.psid = props?.profileInfo?.student_psid || 'NA';
        webengage_params.class_opted = (props?.profileInfo?.classtream || "").split('&')[0];
        webengage_params.stream = props?.profileInfo?.stream;
        webengage_params.state = props?.profileInfo?.exam_state;
        webengage_params.center_name = props?.profileInfo?.exam_center;
        webengage_params.center_code = props?.profileInfo?.exam_center_id;
        webengage_params.anthe_rank_city = props?.tpResultData?.scholarship?.cityRank;
        webengage_params.anthe_rank_state = props?.tpResultData?.scholarship?.stateRank;;
        webengage_params.anthe_all_India_rank = props?.tpResultData?.scholarship?.allIndiaRank;
        webengage_params.scholarship_percent = props?.tpResultData?.percentage;
        webengage_params.scholarship_waiver_message = props?.tpResultData?.scholarship?.remarks;
        webengage_params.grade = props?.tpResultData?.grade;
        webengage_params.dashboard_autologin_url = `https://${window.location.hostname}/?roll_no=${webengage_params.roll_number}&dob=${props?.profileInfo?.student_dob}`;

        let paymentParams = JSON.parse(JSON.stringify(webengage_params));
        paymentParams = {
            ...paymentParams,
            course_name: props?.ecommerce?.finalCourseDetailsPayload?.product_title || "",
            course_id: props?.ecommerce?.finalCourseDetailsPayload?.product_id || "",
            course_term: props?.ecommerce?.finalCourseDetailsPayload?.product_course_term || "",
            payment_order_id: localStorage?.getItem('anthe_order_id') || "",
            gps_link: localStorage.getItem('center-gps') || "",
            center_phone_numbers: localStorage.getItem('center-phone') || "",
            center_address: localStorage.getItem('center-address') || ""
        }

        if (parameters.status === 'success' && parameters.hasOwnProperty('mode') && parameters.type === 'iacstecomm') {
            props.setecommerceSuccess(true)

            // Webengage for Successfull course Purchase
            trackWebEngageEvent(isAkTheDomain?'AKTHE_db_pr_course_payment_successful':'ANTHE_db_pr_course_payment_successful', paymentParams);
        } else if ((parameters.status === 'failure' || parameters.status === 'aborted') && parameters.hasOwnProperty('mode') && parameters.type === 'iacstecomm' && !props?.ecommerce?.retryPayment) {
            props.setecommerceFailed(true)

            // Webengage for Failure course Purchase
            trackWebEngageEvent(isAkTheDomain?'AKTHE_db_pr_course_payment_failure':'ANTHE_db_pr_course_payment_failure', paymentParams);
        } else {
            // Reset all the Redux Values.
            props.setResetReducer()
        }
    }, [parameters.status])

    useEffect(() => {
       if (isPaymentParam) {
    let payStatus = localStorage.getItem('payStatus');

    if (
        profileData &&
        Object.keys(profileData.data).length > 0 &&
        (payStatus !== parameters.status || parameters.status === 'failure') &&
        parameters.editExam === 'false'
    ) {
        const examType = profileData.data.exam_type || 'ANTHE';
        const eventName =
            examType === 'AKTHE'
                ? 'AKTHE_db_mock_payment_status'
                : 'ANTHE_db_mock_payment_status';

        window.webengage.track(eventName, {
            price: localStorage.getItem('mock_amount') || '50',
            'exam type': examType,
            'roll number': profileData.data.roll_number,
            class: (profileData.data?.class || '').toString(),
            stream: profileData.data.stream,
            'payment method': parameters.mode,
            'payment status': parameters.status,
            Year: date.getFullYear()
        });

        localStorage.setItem('payStatus', parameters.status);
        history.push('/dashboard');
    }
}
    }, [parameters.mode, profileData])

    // Set profile data
    useEffect(() => {
        if (profileData) {
            profileData.data.classtream = profileData.data.classtream || profileData.data.class + "&" + profileData.data.stream
            profileData.data.branch_code = profileData.data.branch_code || profileData.data.exam_center_id

            props.setProfileData(profileData.data)
            const { email, exam_type, roll_number, student_dob, class: division, stream, mobile_number, student_firstname, exam_center_id } = profileData.data
            webengage_params.dashboard_autologin_url = `https://${window.location.hostname}/?roll_no=${roll_number}&dob=${student_dob}`

            //mobile num is the unique user identifier being used here
            let loginObj = {
                'exam type': 'anthe',
                'roll number': roll_number,
                dob: student_dob,
                'utm parameters': localStorage.getItem('utmParams'),
                Year: date.getFullYear()
            }

            let sessionObj = {
                'exam type': exam_type,
                'roll number': roll_number,
                dob: student_dob,
                class: division.toString(),
                stream: stream,
                branchcode: exam_center_id,
                Year: date.getFullYear()
            }

            let loginStatus = localStorage.getItem('loginStatus')
            const examType = profileData?.data?.exam_type || 'ANTHE';
            const eventName =
                examType === 'AKTHE'
                    ? 'AKTHE_db_session_start'
                    : 'ANTHE_db_session_start';
            const eventSignin =
                examType === 'AKTHE'
                    ? 'AKTHE_login_sign_in'
                    : 'ANTHE_login_sign_in';
            
            if (loginStatus != 'true') {
                window.webengage.user.login(mobile_number)
                window.webengage.user.setAttribute('we_first_name', student_firstname)
                window.webengage.user.setAttribute('we_phone', mobile_number)
                window.webengage.user.setAttribute('we_email', email)
                window.webengage.track(eventSignin, loginObj)
                window.webengage.track(eventName, sessionObj)
                localStorage.setItem('loginStatus', 'true')
            }
        }

        if (profileData && Object.keys(profileData['data']).length > 0) {
            webengage_params.mobile_number = profileData?.data?.mobile_number;
            webengage_params.roll_number = profileData?.data?.roll_number;
            webengage_params.center_code = profileData?.data?.exam_center_id;
            webengage_params.center_name = profileData?.data?.exam_center;
            webengage_params.class_opted = profileData?.data?.class;
            webengage_params.state = profileData?.data?.exam_state;
            webengage_params.stream = profileData?.data?.stream;
            webengage_params.psid = profileData?.data?.student_psid;
        }

        // eslint-disable-next-line
    }, [profileData])

    // setting dashboard data through reducer 
    useEffect(() => {
        if (dashboardData) {
            dashboardData.data = {
                ...dashboardData.data,
                // These values will be set in result component
                scholarship_msg: props?.dashboardInfo?.scholarship_msg || "",
                overall_percentage: props?.dashboardInfo?.overall_percentage || "",
                scholarship_percentage: props?.dashboardInfo?.scholarship_percentage || "",
            }

            props.setDashboardData(dashboardData.data)
        }
    }, [dashboardData]);


    return (isLoader ? (<Loader />) : (<>
        <Header
            fetchProfileData={fetchProfileData}
            data={props?.token}
            profileData={profileData?.data}
            showEditProfile={true}
        />

        {props?.ecommerce?.ecommerceSuccess ? (
            <ECommerceSuccessful profileData={props.profileInfo} token={props?.token} />
        ) : (
            <>
                <RegistartionSteps />
                {props?.ecommerce?.courseDescVisible || props?.ecommerce?.courseRegisterVisible || props?.ecommerce?.ecommerceFailure ? (
                    <CourseDescription />
                ) : (
                    <>
                        {(!dashboardData?.data?.static_data?.testplayer_down && Number(dashboardData?.data?.main_exam[0]?.view_report) == 1 && dashboardData?.data?.main_exam[0]?.report_text?.toLowerCase() == "view result") ? (
                            <ResultPage />
                        ) : (
                            <ScholarshipTest
                                fetchDashboardData={fetchDashboardData}
                                dashboarderror={dashboarderror}
                                dashApiLoading={isDashboardloading}
                                fetchProfileData={fetchProfileData}
                                updateDetailsResponse={updateDetailsResponse}
                                token={props?.token}
                            />
                        )}
                    </>
                )}
            </>
        )}
        {/* <ToastMessage /> */}
    </>))
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
